var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetamask = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5308 3.56543L17.5371 10.9879L19.3852 6.60874L27.5308 3.56543Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45989 3.56543L14.3733 11.0582L12.6156 6.60874L4.45989 3.56543ZM23.9351 20.7707L21.2734 24.8485L26.9684 26.4154L28.6055 20.8611L23.9351 20.7707ZM3.40527 20.8611L5.03239 26.4154L10.7273 24.8485L8.06566 20.7707L3.40527 20.8611Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4053 13.8805L8.81836 16.281L14.4731 16.5321L14.2722 10.4556L10.4053 13.8805ZM21.5842 13.8805L17.6671 10.3853L17.5365 16.5321L23.1812 16.281L21.5842 13.8805ZM10.7267 24.8485L14.1216 23.1913L11.1887 20.9013L10.7267 24.8485ZM17.868 23.1913L21.2728 24.8485L20.8008 20.9013L17.868 23.1913Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2727 24.8487L17.8678 23.1914L18.139 25.4111L18.1089 26.3452L21.2727 24.8487ZM10.7266 24.8487L13.8904 26.3452L13.8703 25.4111L14.1214 23.1914L10.7266 24.8487Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9408 19.4351L11.1084 18.6015L13.1071 17.6875L13.9408 19.4351ZM18.0488 19.4351L18.8824 17.6875L20.8912 18.6015L18.0488 19.4351Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7271 24.8487L11.2092 20.7709L8.06543 20.8613L10.7271 24.8487ZM20.7911 20.7709L21.2732 24.8487L23.9349 20.8613L20.7911 20.7709ZM23.1816 16.2812L17.5369 16.5323L18.0592 19.435L18.8928 17.6874L20.9016 18.6014L23.1816 16.2812ZM11.1087 18.6014L13.1175 17.6874L13.9411 19.435L14.4735 16.5323L8.81873 16.2812L11.1087 18.6014Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81836 16.2812L11.1887 20.9015L11.1084 18.6014L8.81836 16.2812ZM20.9012 18.6014L20.8008 20.9015L23.1812 16.2812L20.9012 18.6014ZM14.4731 16.5323L13.9408 19.435L14.6037 22.86L14.7543 18.3503L14.4731 16.5323ZM17.5365 16.5323L17.2653 18.3403L17.3858 22.86L18.0588 19.435L17.5365 16.5323Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0588 19.4352L17.3859 22.8602L17.868 23.1916L20.8008 20.9016L20.9012 18.6016L18.0588 19.4352ZM11.1084 18.6016L11.1888 20.9016L14.1216 23.1916L14.6037 22.8602L13.9408 19.4352L11.1084 18.6016Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1089 26.3452L18.139 25.4111L17.8879 25.1901H14.1013L13.8703 25.4111L13.8904 26.3452L10.7266 24.8486L11.8314 25.7526L14.0712 27.3094H17.918L20.1679 25.7526L21.2727 24.8486L18.1089 26.3452Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8686 23.1913L17.3865 22.8599H14.6043L14.1222 23.1913L13.8711 25.411L14.1021 25.1901H17.8887L18.1398 25.411L17.8686 23.1913Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9527 11.47L28.8064 7.37208L27.5308 3.56543L17.8685 10.7368L21.5848 13.8806L26.8378 15.4173L28.0029 14.0613L27.5007 13.6998L28.3042 12.9666L27.6815 12.4845L28.485 11.8718L27.9527 11.47ZM3.19434 7.37208L4.04807 11.47L3.5057 11.8718L4.30921 12.4845L3.69653 12.9666L4.50005 13.6998L3.99785 14.0613L5.1529 15.4173L10.4059 13.8806L14.1221 10.7368L4.45987 3.56543L3.19434 7.37208Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8378 15.4174L21.5848 13.8807L23.1818 16.2812L20.8014 20.9014L23.9351 20.8612H28.6055L26.8378 15.4174ZM10.4059 13.8807L5.15292 15.4174L3.40527 20.8612H8.06566L11.1893 20.9014L8.81896 16.2812L10.4059 13.8807ZM17.5371 16.5323L17.8686 10.7369L19.3952 6.60889H12.6156L14.1222 10.7369L14.4737 16.5323L14.5942 18.3603L14.6043 22.86H17.3864L17.4065 18.3603L17.5371 16.5323Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetamask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/metamask.36a8d545629c5b3abb5901624a16d683.svg";